document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.quotation-form');
  const flowWebhookUrl = 'https://hook.us2.make.com/a6t3yu8gx61i222jn6u21y3c1paz9vr2';
  const MAX_FILE_SIZE = 5 * 1024 * 1024;
  const MIN_SUBMIT_TIME = 3000;   // ms — anti-bot: nadie completa 5 pasos en <3s
  const FETCH_TIMEOUT = 30000;    // ms — corta el "Enviando..." infinito si Make no responde

  // ============================================================
  // CONFIGURACIÓN POR TIPO DE EMPAQUE (única fuente de verdad)
  // Para agregar un nuevo formato, solo se añade aquí.
  // ============================================================
  const packagingTypes = {
    '4selles': {
      label: 'Empaque 4 Selles',
      capacities: [
        { id: 'cap-13g',   label: 'Empaque 13 g (Drip Bags)' },
        { id: 'cap-80g',   label: 'Empaque 80 g' },
        { id: 'cap-125g',  label: 'Empaque 125 g' },
        { id: 'cap-250g',  label: 'Empaque 250 g' },
        { id: 'cap-340g',  label: 'Empaque 340 g' },
        { id: 'cap-500g',  label: 'Empaque 500 g' },
        { id: 'cap-1000g', label: 'Empaque 1.000 g' },
        { id: 'cap-2500g', label: 'Empaque 2.500 g' }
      ],
      quantityRules: {
        'cap-13g':   { options: [10000, 20000, 30000],            min: 10000 },
        'cap-80g':   { options: [6000, 10000, 20000],             min: 6000  },
        'cap-125g':  { options: [4000, 6000, 10000],              min: 4000  },
        'cap-250g':  { options: [1000, 2000, 3000, 5000, 10000],  min: 1000  },
        'cap-340g':  { options: [1000, 2000, 3000, 5000, 10000],  min: 1000  },
        'cap-500g':  { options: [1000, 2000, 3000, 5000, 10000],  min: 1000  },
        'cap-1000g': { options: [1000, 2000, 3000, 5000, 10000],  min: 1000  },
        'cap-2500g': { options: [1000, 2000, 3000, 5000, 10000],  min: 1000  }
      }
    },
    'flatbottom': {
      label: 'Empaque Flatbottom',
      capacities: [
        { id: 'cap-250g', label: 'Empaque 250 g' },
        { id: 'cap-340g', label: 'Empaque 340 g' },
        { id: 'cap-500g', label: 'Empaque 500 g' }
      ],
      quantityRules: {
        'cap-250g': { options: [1000, 2000, 3000, 4000, 5000, 10000], min: 1000 },
        'cap-340g': { options: [1000, 2000, 3000, 4000, 5000, 10000], min: 1000 },
        'cap-500g': { options: [1000, 2000, 3000, 4000, 5000, 10000], min: 1000 }
      }
    }
  };

  // Validadores por campo del último paso (contacto)
  const fieldValidators = {
    contact_name: (v) => {
      if (!v.trim()) return 'Ingresa tu nombre.';
      if (v.trim().length < 2) return 'El nombre es muy corto.';
      return null;
    },
    brand_name: (v) => {
      if (!v.trim()) return 'Ingresa el nombre de tu marca.';
      if (v.trim().length < 2) return 'El nombre de marca es muy corto.';
      return null;
    },
    whatsapp: (v) => {
      const clean = v.replace(/[\s\-\(\)]/g, '');
      if (!clean) return 'Ingresa tu WhatsApp.';
      if (!/^\+?[0-9]{7,15}$/.test(clean)) return 'Ingresa un número válido (solo dígitos, mínimo 7).';
      return null;
    },
    email: (v) => {
      if (!v.trim()) return 'Ingresa tu correo electrónico.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim())) return 'Ingresa un correo válido.';
      return null;
    }
  };

  function formatNumber(n) {
    return n.toLocaleString('es-CO');
  }

  // Limpia el WhatsApp: deja solo dígitos y quita el prefijo 57 si está
  function cleanWhatsApp(raw) {
    if (!raw) return '';
    let digits = raw.replace(/\D/g, '');
    if (digits.startsWith('57') && digits.length > 10) {
      digits = digits.substring(2);
    }
    return digits;
  }

  function readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]);
      reader.onerror = () => reject(new Error('Error leyendo el archivo'));
      reader.readAsDataURL(file);
    });
  }

  forms.forEach(form => {
    const sectionId = form.dataset.sectionId;
    const totalSteps = 5;
    let currentStep = 1;
    let isSubmitted = false;
    let isFileProcessing = false;            // evita avanzar mientras se lee el PDF
    const formLoadTime = Date.now();

    // ============================================================
    // ESTADO CENTRAL — sobrevive a las re-renderizaciones.
    // Esto resuelve el bug de perder selecciones al navegar atrás.
    // ============================================================
    const formState = {
      packagingType: null,                   // '4sellos' | 'flatbottom'
      capacities: [],                        // ['cap-250g', ...]
      quantities: {},                        // { 'cap-250g': { selected: '1000'|'other', custom: '2500' } }
      file: { base64: null, meta: null }
    };

    const steps = form.querySelectorAll('.wizard-step');
    const progressBar = document.getElementById(`wizard-progress-bar-${sectionId}`);
    const progressFill = document.getElementById(`wizard-progress-fill-${sectionId}`);
    const progressText = document.getElementById(`wizard-progress-text-${sectionId}`);
    const capacitiesContainer = document.getElementById(`CapacitiesContainer-${sectionId}`);
    const quantityBlocksContainer = document.getElementById(`QuantityBlocks-${sectionId}`);

    const fileInput = document.getElementById(`QuotationFile-${sectionId}`);
    const fileWrapper = document.getElementById(`FileWrapper-${sectionId}`);
    const fileNameEl = document.getElementById(`FileName-${sectionId}`);
    const fileErrorEl = document.getElementById(`FileError-${sectionId}`);
    const consentCheckbox = document.getElementById(`FileConsent-${sectionId}`);
    const consentErrorEl = document.getElementById(`ConsentError-${sectionId}`);

    const dataConsentCheckbox = document.getElementById(`DataConsent-${sectionId}`);
    const dataConsentErrorEl = document.getElementById(`DataConsentError-${sectionId}`);

    const nextBtns = form.querySelectorAll('.btn-next');
    const prevBtns = form.querySelectorAll('.btn-prev');
    const submitBtn = document.getElementById(`QuotationSubmit-${sectionId}`);
    const submitTextEl = submitBtn.querySelector('.quotation-form__submit-text');
    const submitDefaultText = submitTextEl.textContent;

    const successEl = document.getElementById(`QFSuccess-${sectionId}`);
    const errorEl = document.getElementById(`QFError-${sectionId}`);

    function setFieldError(el, message) {
      if (!el) return;
      el.textContent = message || '';
      el.classList.toggle('is-visible', !!message);
    }

    function hideStatus() {
      successEl.classList.remove('is-visible');
      errorEl.classList.remove('is-visible');
    }

    // ==========================================
    // 1. MANEJO DE ARCHIVOS (con drag & drop)
    // ==========================================
    function showFileError(msg) {
      setFieldError(fileErrorEl, msg);
      fileWrapper.classList.add('has-error');
      fileWrapper.classList.remove('has-file');
    }

    function clearFileError() {
      setFieldError(fileErrorEl, '');
      fileWrapper.classList.remove('has-error');
    }

    function resetFile() {
      formState.file.base64 = null;
      formState.file.meta = null;
      fileNameEl.textContent = '';
      fileNameEl.classList.remove('is-success');
      fileInput.value = '';
      fileWrapper.classList.remove('has-file');
    }

    async function processFile(file) {
      clearFileError();

      if (!file) {
        resetFile();
        return;
      }

      const isPdf = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
      if (!isPdf) {
        showFileError('El archivo debe ser un PDF.');
        resetFile();
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        showFileError(`El archivo supera los 5 MB. Tamaño actual: ${(file.size / 1024 / 1024).toFixed(2)} MB.`);
        resetFile();
        return;
      }

      try {
        isFileProcessing = true;
        fileNameEl.textContent = 'Procesando: ' + file.name;
        const base64 = await readFileAsBase64(file);

        // Verificación de firma: un PDF real empieza por "%PDF-" => base64 "JVBER..."
        // Bloquea archivos renombrados (un .docx daría "UEsD...", un .png "iVBOR...").
        if (!base64.startsWith('JVBER')) {
          showFileError('El archivo no parece ser un PDF válido. Verifica que no esté renombrado.');
          resetFile();
          return;
        }

        formState.file.base64 = base64;
        formState.file.meta = { name: file.name, size: file.size, type: file.type || 'application/pdf' };
        fileNameEl.textContent = `✓ ${file.name} (${(file.size / 1024).toFixed(1)} KB)`;
        fileNameEl.classList.add('is-success');
        fileWrapper.classList.add('has-file');
      } catch (err) {
        showFileError('No se pudo procesar el archivo. Intenta de nuevo.');
        resetFile();
      } finally {
        isFileProcessing = false;
      }
    }

    fileInput.addEventListener('change', (e) => processFile(e.target.files[0]));

    ['dragenter', 'dragover'].forEach(evt => {
      fileWrapper.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        fileWrapper.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach(evt => {
      fileWrapper.addEventListener(evt, (e) => {
        e.preventDefault();
        e.stopPropagation();
        fileWrapper.classList.remove('is-dragover');
      });
    });
    fileWrapper.addEventListener('drop', (e) => {
      const file = e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) {
        try {
          const dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;
        } catch (_) { /* no crítico */ }
        processFile(file);
      }
    });

    consentCheckbox.addEventListener('change', () => {
      if (consentCheckbox.checked) setFieldError(consentErrorEl, '');
    });

    if (dataConsentCheckbox) {
      dataConsentCheckbox.addEventListener('change', () => {
        if (dataConsentCheckbox.checked) setFieldError(dataConsentErrorEl, '');
      });
    }

    // ==========================================
    // 2. TIPO DE EMPAQUE (paso 2)
    // ==========================================
    const typeRadios = form.querySelectorAll('input[name="packaging_type"]');
    typeRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        // Si cambia de tipo, las capacidades/cantidades del tipo anterior ya no aplican
        if (formState.packagingType !== radio.value) {
          formState.packagingType = radio.value;
          formState.capacities = [];
          formState.quantities = {};
        }
        const err = document.getElementById(`ErrorStep2-${sectionId}`);
        if (err) err.classList.remove('is-visible');
      });
    });

    // ==========================================
    // 3. RENDER DE CAPACIDADES (paso 3, según tipo)
    // ==========================================
    function renderCapacities() {
      if (!formState.packagingType) {
        capacitiesContainer.innerHTML = '';
        return;
      }
      const type = packagingTypes[formState.packagingType];

      capacitiesContainer.innerHTML = type.capacities.map(cap => {
        const checked = formState.capacities.includes(cap.id) ? 'checked' : '';
        return `
          <div class="quotation-form__capacity-option">
            <input type="checkbox" id="${cap.id}-${sectionId}" name="capacities" value="${cap.id}" data-capacity-label="${cap.label}" class="custom-checkbox-input" ${checked}>
            <label for="${cap.id}-${sectionId}">
              <span class="custom-checkbox-visual"></span>
              <span>${cap.label}</span>
            </label>
          </div>
        `;
      }).join('');

      capacitiesContainer.querySelectorAll('input[name="capacities"]').forEach(cb => {
        cb.addEventListener('change', () => {
          if (cb.checked) {
            if (!formState.capacities.includes(cb.value)) formState.capacities.push(cb.value);
          } else {
            formState.capacities = formState.capacities.filter(id => id !== cb.value);
            delete formState.quantities[cb.value];
          }
          if (formState.capacities.length > 0) {
            const err = document.getElementById(`ErrorStep3-${sectionId}`);
            if (err) err.classList.remove('is-visible');
          }
        });
      });
    }

    // ==========================================
    // 4. RENDER DE CANTIDADES (paso 4, preserva estado)
    // ==========================================
    function renderQuantityBlocks() {
      if (!formState.packagingType || formState.capacities.length === 0) {
        quantityBlocksContainer.innerHTML = '';
        return;
      }
      const type = packagingTypes[formState.packagingType];

      // Render en el orden definido por el tipo (no por orden de clic)
      const orderedCaps = type.capacities
        .map(c => c.id)
        .filter(id => formState.capacities.includes(id));

      quantityBlocksContainer.innerHTML = orderedCaps.map(capId => {
        const cap = type.capacities.find(c => c.id === capId);
        const rule = type.quantityRules[capId] || { options: [1000], min: 1000 };
        const saved = formState.quantities[capId] || { selected: null, custom: '' };

        const optionsHtml = rule.options.map(qty => {
          const inputId = `qty-${capId}-${qty}-${sectionId}`;
          const checked = String(saved.selected) === String(qty) ? 'checked' : '';
          return `
            <div class="quotation-form__capacity-option">
              <input type="radio" id="${inputId}" name="qty_${capId}" value="${qty}" data-qty-for="${capId}" class="custom-checkbox-input" ${checked}>
              <label for="${inputId}">
                <span class="custom-checkbox-visual custom-radio-visual"></span>
                <span>${formatNumber(qty)} unidades</span>
              </label>
            </div>
          `;
        }).join('');

        const otherId = `qty-${capId}-other-${sectionId}`;
        const otherInputId = `qty-${capId}-other-input-${sectionId}`;
        const isOther = saved.selected === 'other';
        const otherChecked = isOther ? 'checked' : '';
        const otherVisible = isOther ? ' is-visible' : '';
        const otherValue = isOther ? (saved.custom || '') : '';

        return `
          <div class="quotation-form__quantity-block">
            <h4 class="quotation-form__quantity-title">${cap ? cap.label : capId}</h4>
            <div class="quotation-form__capacities-grid">
              ${optionsHtml}
              <div class="quotation-form__capacity-option">
                <input type="radio" id="${otherId}" name="qty_${capId}" value="other" data-qty-for="${capId}" class="custom-checkbox-input" ${otherChecked}>
                <label for="${otherId}">
                  <span class="custom-checkbox-visual custom-radio-visual"></span>
                  <span>Otra cantidad</span>
                </label>
              </div>
            </div>

            <div class="quotation-form__quantity-other${otherVisible}" data-other-wrapper="${capId}">
              <div class="field">
                <input type="number" id="${otherInputId}" name="qty_${capId}_other" data-cap-id="${capId}" class="field__input" min="${rule.min}" step="1" value="${otherValue}" placeholder="Mínimo ${formatNumber(rule.min)} unidades" ${otherChecked ? 'required' : ''}>
                <p class="field-error" data-error-for="qty_${capId}_other" role="alert"></p>
              </div>
            </div>
          </div>
        `;
      }).join('');

      // Radios: guardan en estado + muestran/ocultan "otra cantidad"
      quantityBlocksContainer.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
          const capId = e.target.dataset.qtyFor;
          const otherWrapper = quantityBlocksContainer.querySelector(`[data-other-wrapper="${capId}"]`);
          const otherInput = otherWrapper.querySelector('input[type="number"]');
          const otherError = otherWrapper.querySelector('.field-error');

          if (!formState.quantities[capId]) formState.quantities[capId] = { selected: null, custom: '' };
          formState.quantities[capId].selected = e.target.value;

          if (e.target.value === 'other') {
            otherWrapper.classList.add('is-visible');
            otherInput.required = true;
            setTimeout(() => otherInput.focus(), 100);
          } else {
            otherWrapper.classList.remove('is-visible');
            otherInput.required = false;
            otherInput.value = '';
            formState.quantities[capId].custom = '';
            setFieldError(otherError, '');
          }

          const err = document.getElementById(`ErrorStep4-${sectionId}`);
          if (err) err.classList.remove('is-visible');
        });
      });

      // Input "otra cantidad": guarda en estado + valida
      quantityBlocksContainer.querySelectorAll('input[type="number"]').forEach(input => {
        const capId = input.dataset.capId;

        input.addEventListener('input', () => {
          if (!formState.quantities[capId]) formState.quantities[capId] = { selected: 'other', custom: '' };
          formState.quantities[capId].custom = input.value;
          const errEl = input.parentElement.querySelector('.field-error');
          if (errEl.classList.contains('is-visible')) {
            const val = parseInt(input.value, 10);
            const min = parseInt(input.min, 10);
            if (input.value && !isNaN(val) && val >= min) setFieldError(errEl, '');
          }
        });

        input.addEventListener('blur', () => {
          if (!input.required) return;
          const errEl = input.parentElement.querySelector('.field-error');
          const val = parseInt(input.value, 10);
          const min = parseInt(input.min, 10);
          if (!input.value) {
            setFieldError(errEl, 'Ingresa una cantidad.');
          } else if (isNaN(val) || val < min) {
            setFieldError(errEl, `La cantidad mínima es ${formatNumber(min)} unidades.`);
          } else {
            setFieldError(errEl, '');
          }
        });
      });
    }

    // ==========================================
    // 5. VALIDACIÓN EN VIVO DEL PASO DE CONTACTO
    // ==========================================
    function setupLiveValidation() {
      Object.keys(fieldValidators).forEach(name => {
        const input = form.querySelector(`[name="${name}"]`);
        if (!input) return;
        const fieldWrap = input.closest('.field--floating');
        const errorEl = form.querySelector(`[data-error-for="${name}"]`);

        const validate = () => {
          const err = fieldValidators[name](input.value);
          if (err) {
            fieldWrap.classList.add('is-invalid');
            fieldWrap.classList.remove('is-valid');
            setFieldError(errorEl, err);
            return false;
          }
          fieldWrap.classList.remove('is-invalid');
          fieldWrap.classList.add('is-valid');
          setFieldError(errorEl, '');
          return true;
        };

        input.addEventListener('blur', validate);
        input.addEventListener('input', () => {
          if (fieldWrap.classList.contains('is-invalid')) validate();
        });
      });
    }

    setupLiveValidation();

    // ==========================================
    // 6. NAVEGACIÓN Y VALIDACIÓN POR PASO
    // ==========================================
    function updateView() {
      steps.forEach(step => step.classList.remove('is-active'));
      form.querySelector(`.wizard-step[data-step="${currentStep}"]`).classList.add('is-active');

      const percentage = (currentStep / totalSteps) * 100;
      progressFill.style.width = `${percentage}%`;
      progressText.textContent = `Paso ${currentStep} de ${totalSteps}`;
      if (progressBar) progressBar.setAttribute('aria-valuenow', currentStep);

      if (currentStep === 3) renderCapacities();
      if (currentStep === 4) renderQuantityBlocks();
    }

    function validateCurrentStep() {
      let isValid = true;

      if (currentStep === 1) {
        if (isFileProcessing) {
          showFileError('Espera a que termine de cargar el archivo.');
          return false;
        }
        if (!formState.file.base64) {
          showFileError('Adjunta tu archivo PDF para continuar.');
          isValid = false;
        }
        if (!consentCheckbox.checked) {
          setFieldError(consentErrorEl, 'Debes confirmar que el diseño es final.');
          isValid = false;
        }
      }
      else if (currentStep === 2) {
        if (!formState.packagingType) {
          const err = document.getElementById(`ErrorStep2-${sectionId}`);
          if (err) err.classList.add('is-visible');
          isValid = false;
        }
      }
      else if (currentStep === 3) {
        if (formState.capacities.length === 0) {
          const err = document.getElementById(`ErrorStep3-${sectionId}`);
          if (err) err.classList.add('is-visible');
          isValid = false;
        }
      }
      else if (currentStep === 4) {
        const errMsg = document.getElementById(`ErrorStep4-${sectionId}`);
        const rules = packagingTypes[formState.packagingType].quantityRules;

        formState.capacities.forEach(capId => {
          const q = formState.quantities[capId];
          if (!q || !q.selected) {
            isValid = false;
            return;
          }
          if (q.selected === 'other') {
            const numInput = form.querySelector(`input[name="qty_${capId}_other"]`);
            const errorEl = numInput ? numInput.parentElement.querySelector('.field-error') : null;
            const val = parseInt(q.custom, 10);
            const min = rules[capId] ? rules[capId].min : 1000;
            if (!q.custom) {
              setFieldError(errorEl, 'Ingresa una cantidad.');
              isValid = false;
            } else if (isNaN(val) || val < min) {
              setFieldError(errorEl, `La cantidad mínima es ${formatNumber(min)} unidades.`);
              isValid = false;
            }
          }
        });
        if (errMsg) errMsg.classList.toggle('is-visible', !isValid);
      }
      else if (currentStep === 5) {
        Object.keys(fieldValidators).forEach(name => {
          const input = form.querySelector(`[name="${name}"]`);
          const fieldWrap = input.closest('.field--floating');
          const errorEl = form.querySelector(`[data-error-for="${name}"]`);
          const err = fieldValidators[name](input.value);
          if (err) {
            fieldWrap.classList.add('is-invalid');
            setFieldError(errorEl, err);
            isValid = false;
          } else {
            fieldWrap.classList.remove('is-invalid');
            fieldWrap.classList.add('is-valid');
            setFieldError(errorEl, '');
          }
        });

        // Habeas Data obligatorio
        if (dataConsentCheckbox && !dataConsentCheckbox.checked) {
          setFieldError(dataConsentErrorEl, 'Debes autorizar el tratamiento de tus datos para continuar.');
          isValid = false;
        }
      }

      return isValid;
    }

    function scrollToFormTop() {
      const formPosition = form.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: formPosition - 120, behavior: 'smooth' });
    }

    nextBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (validateCurrentStep()) {
          currentStep++;
          updateView();
          scrollToFormTop();
        } else {
          const firstError = form.querySelector('.wizard-step.is-active .field-error.is-visible, .wizard-step.is-active .wizard-error.is-visible');
          if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    prevBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        currentStep--;
        updateView();
        scrollToFormTop();
      });
    });

    // ==========================================
    // 7. ENVÍO DEL FORMULARIO
    // ==========================================
    function fakeSuccess() {
      // Para bots: simulamos éxito sin enviar nada (no delatamos la trampa)
      isSubmitted = true;
      submitBtn.classList.remove('is-loading');
      submitBtn.classList.add('is-sent');
      submitBtn.disabled = true;
      submitTextEl.textContent = 'Solicitud de cotización enviada';
      successEl.classList.add('is-visible');
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (isSubmitted) return;
      if (!validateCurrentStep()) return;

      // Anti-bot 1: honeypot lleno => descarta silenciosamente
      const hp = form.querySelector('[name="company_website"]');
      if (hp && hp.value.trim() !== '') { fakeSuccess(); return; }

      // Anti-bot 2: envío demasiado rápido => descarta silenciosamente
      if (Date.now() - formLoadTime < MIN_SUBMIT_TIME) { fakeSuccess(); return; }

      hideStatus();
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
      submitTextEl.textContent = 'Enviando...';

      const type = packagingTypes[formState.packagingType];
      const orderedCaps = type.capacities.map(c => c.id).filter(id => formState.capacities.includes(id));

      const selectedCapacities = orderedCaps.map(capId => {
        const cap = type.capacities.find(c => c.id === capId);
        const q = formState.quantities[capId] || {};
        let quantity = null;
        let isCustom = false;
        if (q.selected === 'other') {
          quantity = parseInt(q.custom, 10);
          isCustom = true;
        } else if (q.selected) {
          quantity = parseInt(q.selected, 10);
        }
        return {
          capacity_id: capId,
          capacity_label: cap ? cap.label : capId,
          quantity: quantity,
          quantity_formatted: quantity ? formatNumber(quantity) : null,
          is_custom_quantity: isCustom
        };
      });

      const whatsappClean = cleanWhatsApp(form.querySelector('[name="whatsapp"]').value);

      const payload = {
        submitted_at: new Date().toISOString(),
        source: 'shopify_quotation_form_wizard',
        packaging_type: formState.packagingType,
        packaging_type_label: type.label,
        contact: {
          name: form.querySelector('[name="contact_name"]').value.trim(),
          brand: form.querySelector('[name="brand_name"]').value.trim(),
          whatsapp: whatsappClean,
          whatsapp_raw: form.querySelector('[name="whatsapp"]').value.trim(),
          email: form.querySelector('[name="email"]').value.trim()
        },
        design_file: {
          name: formState.file.meta ? formState.file.meta.name : null,
          size_bytes: formState.file.meta ? formState.file.meta.size : null,
          mime_type: formState.file.meta ? formState.file.meta.type : null,
          base64: formState.file.base64
        },
        design_file_confirmed_final: consentCheckbox.checked,
        data_processing_authorized: dataConsentCheckbox ? dataConsentCheckbox.checked : null,
        data_processing_authorized_at: (dataConsentCheckbox && dataConsentCheckbox.checked) ? new Date().toISOString() : null,
        capacities: selectedCapacities
      };

      // Timeout: aborta si Make no responde en FETCH_TIMEOUT
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

      try {
        const response = await fetch(flowWebhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal
        });
        clearTimeout(timeoutId);

        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);

        isSubmitted = true;
        submitBtn.classList.remove('is-loading');
        submitBtn.classList.add('is-sent');
        submitTextEl.textContent = 'Solicitud de cotización enviada';
        successEl.classList.add('is-visible');

        setTimeout(() => {
          successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);

      } catch (err) {
        clearTimeout(timeoutId);
        console.error('Error enviando formulario:', err);
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        submitTextEl.textContent = submitDefaultText;

        // Mensaje específico si fue timeout
        const statusSpan = errorEl.querySelector('span');
        if (statusSpan) {
          statusSpan.textContent = (err.name === 'AbortError')
            ? 'El servidor tardó demasiado en responder. Intenta de nuevo o escríbenos por WhatsApp.'
            : 'Revisa tu conexión e intenta de nuevo. Si el problema persiste, escríbenos por WhatsApp.';
        }
        errorEl.classList.add('is-visible');
        setTimeout(() => {
          errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      }
    });

    updateView();
  });
});